export default {
  horizontalMenuState: (state) => state.horizontalMenu,
  miniSidebarState: (state) => state.miniSidebarMenu,
  activePage: (state) => state.activePage,
  langState: (state) => state.lang,
  timeZoneState: (state) => state.timeZone,
  userState: (state) => state.user,
  organizationState: (state) => state.organization,
  langOptionState: (state) => state.langOption,
  timeZoneOptionState: (state) => state.timeZoneOption,
  colorState: (state) => state.colors,
};
